export default __webpack_public_path__ + "static/media/pw_app_logo.850d74f2.png";